import { createAsyncThunk } from "@reduxjs/toolkit";
import { NotificationProps, NotificationState } from "./types";
import ApiService from "services/ApiService";


export const notificationUpdate = createAsyncThunk(
  "notification/update",
  async (data: NotificationProps) => {
    return {
      data: data,
      status: "success",
      error: null,
    };
  }
);

export const notificationClearCounter = createAsyncThunk(
  "notification/clear-counter",
  async () => {
    return {
      status: "success",
      error: null,
    };
  }
);

export const setFirebaseToken = createAsyncThunk(
  "notification/token",
  async (token: string) => {
    return {
      data: token,
      status: "success",
      error: null,
    };
  }
);

type GetNotificationsPayload = {
  data: NotificationProps[]; 
  status: 'success' | 'error' | 'empty'; 
  message?: string; 
  total?:number;
};

export const getNotifications = createAsyncThunk<GetNotificationsPayload, { merchantId: number; token: string, page_no: number, page_size: number, sort_by: string, sort_direction: string }>(
  "notification/getAll",
  async ({ merchantId, token, page_no, page_size, sort_by, sort_direction }) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await ApiService.get(
        `${process.env.REACT_APP_API_URL}/merchants/notification?merchant_id=${merchantId}&page_no=${page_no}&page_size=${page_size}&sort_by=${sort_by}&sort_direction=${sort_direction}`,
        config
      );

      console.log("API Response:", response);

    
      if (response && response.data && response.data.data) {
        return {
          data: response.data.data,  
          status: "success", 
          total: response.data.pageData?.totalElements || 0,
        };
      } else {
        return {
          data: [], 
          total: 0,
          status: "empty",
          message: "No notifications found", 
        };
      }
    } catch (err) {
      return {
        data: [], 
        total: 0,
        status: "error",
        message: err instanceof Error ? err.message : "Something went wrong!", 
      };
    }
  }
);


export const getUnreadNotifications = createAsyncThunk(
  "notification/getUnread",
  async ({ merchantId, token }:{merchantId: number; token: string}) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await ApiService.get(
        `${process.env.REACT_APP_API_URL}/merchants/notification/unread?merchantId=${merchantId}`,
        config
      );

      console.log('unread notifications', response);

      if (response && response.data) {
        return {
          unreadNotifications: response.data, 
          status: "success",
        };
      } else {
        return {
          unreadNotifications: [],
          status: "empty",
          message: "No unread notifications found",
        };
      }
    } catch (err) {
      return {
        unreadNotifications: [],
        status: "error",
        message: err instanceof Error ? err.message : "Something went wrong!",
      };
    }
  }
);

export const updateNotificationReadStatus = createAsyncThunk(
  "notification/update-read-status",
  async ({ notificationId, isRead, token, markAll, merchantId }: {merchantId?: number; notificationId?: number; isRead:boolean; token: string, markAll?: boolean }) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
       const url = new URL(`${process.env.REACT_APP_API_URL}/merchants/notification`);
        
       if(merchantId){
        url.searchParams.append('merchantId', merchantId.toString());
        }
       if(notificationId){
        url.searchParams.append('notificationId', notificationId.toString());
        }
        if(isRead !== undefined){
        url.searchParams.append('isRead', isRead.toString());
        }
        if(markAll){
        url.searchParams.append('markAll', markAll.toString());
        };

        const response = await ApiService.put(url.toString(), {}, config);

        if (response && response.data) {
          return {
            data: response.data,
            status: "success",
            message: response.data,
            error: null,
          };
        }
    } catch (err) {
      console.error('Error updating notification read status:', err);
      return {
        status: "error",
        message: err instanceof Error ? err.message : "Something went wrong!",
        error: err,
      };
    }
  }
);

export const deleteAllNotifications = createAsyncThunk(
  "notification/deleteAll",
  async ({merchantId, notificationId, deleteAll, token}: {merchantId: any, notificationId?: any, deleteAll: any, token: any}) => {
    try{
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const url = new URL(`${process.env.REACT_APP_API_URL}/merchants/notification`);
      if (merchantId){
        url.searchParams.append('merchantId', merchantId);
      }
      if (notificationId){
        url.searchParams.append('notificationId', notificationId);
      }
      url.searchParams.append("deleteAll", deleteAll);

      const response = await ApiService.delete(url.toString(), config);

     if (response && response.data){
        return {
          data: response.data,
          status: "success",
          message: response.data,
          error: null,
        };
      }
    } catch (err) {
      console.error('Error deleting notifications:', err);
      return {
        status: "error",
        error: err instanceof Error ? err.message : "Something went wrong!",
      };
    }
  }
);


export {};
